"use client";
import Image from "next/image";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "../common/CommonSubtitle";
import bgHeroImage from "@/assets/images/features/hero-background.svg";
import {
  SignUpHubspotButtonUrl,
} from "@/utils/hubspot-contants";
import { ItemInfoProps } from "@/app/ai/enterprise-search/root";
import Lottie from "lottie-react";
import CommonButton from "../common/CommonButton";
import CommonVideoButton from "../common/CommonVideoButton";
import CustomButton from "../common/CustomButton";

const EnterpriseTop = ({
  itemInfo,
  scrollToFeatures,
}: {
  itemInfo: ItemInfoProps;
  scrollToFeatures: () => void;
}) => {
  return (
    <>
      <section className="relative z-10 overflow-hidden">
        <div className="pt-[72px]">
          <div
            className="xl:pb-[100px] xl:pt-[76px]"
            style={{
              background: `url(${bgHeroImage.src})`,
              backgroundColor: "#ffffff",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="container mx-auto px-4 text-[#202020] xl:px-6">
              <div className="mt-4 flex flex-col items-center justify-between gap-4 py-16 xl:flex-row xl:gap-12 xl:py-0">
                <div className="w-full xl:max-w-[500px]">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                      <CommonTitle
                        as="h1"
                        color="#202020"
                        fontSizeClass="text-[36px] lg:text-[48px]"
                        fontWeightClass="font-bold"
                      >
                        {itemInfo.introText}
                      </CommonTitle>
                    </div>
                    <CommonSubtitle
                      color="#202020"
                      fontSizeWeight="text-[16px] xl:text-[18px] font-normal"
                    >
                      {itemInfo.descriptionText}
                    </CommonSubtitle>
                    <div className="flex flex-wrap items-center gap-2 xl:gap-4">
                      <CustomButton
                        text="Request Demo"
                        url={itemInfo?.buttonUrl || SignUpHubspotButtonUrl}
                        variant="primary"
                        version="black"
                      />
                      <CustomButton
                        text="Watch Video"
                        url="https://www.youtube.com/embed/rQckpCTjTpc?autoplay=1"
                        variant="secondary"
                        version="black"
                      />
                    </div>
                  </div>
                </div>
                <div className="relative w-full">
                  {itemInfo.featuredVideoJson ? (
                    <div aria-hidden="true">
                      <Lottie
                        animationData={itemInfo.featuredVideoJson}
                        alt="Kroolo Enterprise Search - AI-powered search interface"
                        className="h-full w-full object-contain"
                        width={500}
                        height={500}
                        loop
                        autoplay
                      />
                    </div>
                  ) : (
                    <Image
                      src={itemInfo.bannerImage || ""}
                      alt="Kroolo Enterprise Search - AI-powered search interface"
                      className="h-full w-full object-contain"
                      width={500}
                      height={500}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EnterpriseTop;
